import { useEffect, useState } from "react";
import ReactSelect from "react-select";
import EstadoBadge from "../components/EstadoBadge";
import Loader from "../components/Loader";
import {
  listProveedorLazy,
  updateProveedor,
  createProveedor,
  changeProveedor,
} from "../api/proveedores";

import {
  listDepartamento012,
  listMunicipio013,
  listActividadEconomica19,
} from "../api/hacienda";

const Proveedores = () => {
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [actividad, setActividadEconomica] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [proveedores, setproveedores] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [currentId, setCurrentId] = useState(null);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [buscar, setBuscar] = useState("");

  const [form, setForm] = useState({
    name: "",
    nombre_comercial: "",
    nit: "",
    dui: "",
    nrc: "",
    actividad: "",
    departamento: "",
    municipio: "",
    direccion: "",
    telefono: "",
    correo: "",
    status: "1",
  });

  const fetchData = async (p = 1) => {
    try {
      const data = await listProveedorLazy(p, limit, buscar);
      setproveedores(data.data);

      const dep = await listDepartamento012({});
      setDepartamentos(dep.data);

      const mun = await listMunicipio013({});
      setMunicipios(mun.data);

      const act = await listActividadEconomica19({});
      setActividadEconomica(act.data);

      setTotalPages(data.totalPages);

    } catch (error) {
      console.error("Error al obtener las categorías", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page);
    // eslint-disable-next-line 
  }, [page, limit, buscar]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const openModalForNew = () => {
    setForm({
      name: "",
      nombre_comercial: "",
      nit: "",
      dui: "",
      nrc: "",
      actividad: "",
      departamento: "",
      municipio: "",
      direccion: "",
      telefono: "",
      correo: "",
      status: "1",
    });
    setEditMode(false);
    setCurrentId(null);
    setShowModal(true);
  };

  const openModalForEdit = (c) => {
    setForm({
      name: c.name || "",
      nombre_comercial: c.nombre_comercial || "",
      nit: c.nit || "",
      dui: c.dui || "",
      nrc: c.nrc || "",
      actividad: c.id_actividad_economica?.toString() || "",
      departamento: c.id_departamento?.toString() || "",
      municipio: c.id_municipio?.toString() || "",
      direccion: c.direccion || "",
      telefono: c.telefono || "",
      correo: c.correo || "",
      status: String(c.status ?? ""),
    });
    setCurrentId(c.id);
    setEditMode(true);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = {
        name: form.name,
        nombre_comercial: form.nombre_comercial,
        nit: form.nit,
        dui: form.dui,
        nrc: form.nrc,
        id_actividad_economica: form.actividad,
        id_departamento: form.departamento,
        id_municipio: form.municipio,
        direccion: form.direccion,
        telefono: form.telefono,
        correo: form.correo,
        status: form.status,
      };

      if (editMode) {
        await updateProveedor(currentId, data);
      } else {
        await createProveedor(data);
      }

      await fetchData();
      setShowModal(false);
    } catch (error) {
      console.error("Error al guardar el proveedor", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleToggleStatus = async (c) => {
    const newStatus = c.status === 1 ? 0 : 1;
    try {
      await changeProveedor(c.id, { status: newStatus });
      await fetchData();
    } catch (error) {
      console.error("Error al cambiar el estado del proveedor", error);
    }
  };

  const handleSelectChange = (value, name) => {
    setForm((prev) => ({ ...prev, [name]: value ? value.value : "" }));
  };

  const opcionesDepartamento = departamentos.map((d) => ({
    value: d.id.toString(),
    label: `${d.codigo} | ${d.name}`,
  }));

  const opcionesMunicipio = municipios.map((d) => ({
    value: d.id.toString(),
    label: `${d.codigo} | ${d.name}`,
  }));

  const opcionesActividad = actividad.map((d) => ({
    value: d.id.toString(),
    label: `${d.codigo} | ${d.name}`,
  }));

  if (loading) return <Loader />;
  return (
    <div className="p-3 sm:p-6 max-w-7xl mx-auto">
      {/* Encabezado */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 sm:mb-6 gap-3">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800">Gestión de Proveedores</h2>
          <p className="text-xs sm:text-sm text-slate-500 mt-1">Administre el directorio de proveedores autorizados</p>
        </div>
        <button
          onClick={openModalForNew}
          className="w-full sm:w-auto bg-indigo-600 text-white px-4 py-2.5 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm shadow-indigo-200 font-medium flex items-center justify-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Agregar Proveedor
        </button>
      </div>

      {/* Filtros */}
      <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-3 mb-4 sm:mb-6 bg-white p-3 sm:p-4 rounded-xl shadow-sm border border-slate-200">
        <div className="relative flex-grow">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="h-5 w-5 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Buscar proveedor por nombre, NIT..."
            value={buscar}
            onChange={(e) => setBuscar(e.target.value)}
            className="pl-10 pr-4 py-2 w-full border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors bg-slate-50 focus:bg-white text-sm"
          />
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-500 font-medium whitespace-nowrap">Mostrar:</span>
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            className="border border-slate-300 rounded-lg px-3 py-2 bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
          >
            {[10, 15, 25, 50, 100, 250, 500, 1000].map(num => (
              <option key={num} value={num}>
                {num} registros
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Tabla de proveedores */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden relative">

        {/* Tabla — solo en md+ */}
        <div className="hidden md:block overflow-x-auto custom-scrollbar">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase border-b border-slate-200">
              <tr>
                <th className="px-4 py-3 font-semibold">Nombre</th>
                <th className="px-4 py-3 font-semibold">Nombre Comercial</th>
                <th className="px-4 py-3 font-semibold">N° Registro</th>
                <th className="px-4 py-3 font-semibold">Dui</th>
                <th className="px-4 py-3 font-semibold">Nit</th>
                <th className="px-4 py-3 font-semibold">Telefono</th>
                <th className="px-4 py-3 font-semibold">Actividad Económica</th>
                <th className="px-4 py-3 font-semibold">Departamento</th>
                <th className="px-4 py-3 font-semibold">Municipio</th>
                <th className="px-4 py-3 font-semibold text-center">Estado</th>
                <th className="px-4 py-3 font-semibold text-center sticky right-0 bg-slate-100 border-l border-slate-200 z-10 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.05)]">Opciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {proveedores.map((proveedore) => (
                <tr
                  key={proveedore.id}
                  className="hover:bg-indigo-50/50 transition-colors group"
                >
                  <td className="px-4 py-3 text-slate-700 font-medium whitespace-nowrap">{proveedore.name}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{proveedore.nombre_comercial}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{proveedore.nrc}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{proveedore.dui}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{proveedore.nit}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{proveedore.telefono}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{proveedore.CodigoActividadEconomica?.name}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{proveedore.Departamento?.name}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{proveedore.Municipio?.name}</td>
                  <td className="px-4 py-3 text-center">
                    <EstadoBadge status={proveedore.status} />
                  </td>
                  <td className="px-4 py-3 sticky right-0 bg-slate-100 group-hover:bg-slate-200 border-l border-slate-200 z-0 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.03)] transition-colors">
                    <div className="flex items-center justify-center gap-2">
                      <button
                        type="button"
                        onClick={() => openModalForEdit(proveedore)}
                        className="bg-white border border-slate-200 text-slate-600 px-3 py-1.5 rounded-lg hover:bg-slate-50 hover:text-indigo-600 transition-colors text-xs font-medium"
                      >
                        Editar
                      </button>

                      {proveedore.status === 1 ? (
                        <button
                          type="button"
                          onClick={() => handleToggleStatus(proveedore)}
                          className="bg-red-50 text-red-600 border border-red-100 px-3 py-1.5 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium"
                        >
                          Deshabilitar
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => handleToggleStatus(proveedore)}
                          className="bg-emerald-50 text-emerald-600 border border-emerald-100 px-3 py-1.5 rounded-lg hover:bg-emerald-100 transition-colors text-xs font-medium"
                        >
                          Activar
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cards — solo en móvil */}
        <div className="md:hidden divide-y divide-slate-100">
          {proveedores.map((proveedore) => (
            <div key={proveedore.id} className="p-4">
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-slate-800 text-sm truncate">{proveedore.name}</p>
                  {proveedore.nombre_comercial && proveedore.nombre_comercial !== proveedore.name && (
                    <p className="text-xs text-slate-500 truncate">{proveedore.nombre_comercial}</p>
                  )}
                </div>
                <EstadoBadge status={proveedore.status} />
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs mb-3">
                {proveedore.nit && (
                  <div>
                    <span className="text-slate-400 font-medium uppercase tracking-wide">NIT</span>
                    <p className="text-slate-700 font-mono font-medium">{proveedore.nit}</p>
                  </div>
                )}
                {proveedore.nrc && (
                  <div>
                    <span className="text-slate-400 font-medium uppercase tracking-wide">NRC</span>
                    <p className="text-slate-700 font-mono font-medium">{proveedore.nrc}</p>
                  </div>
                )}
                {proveedore.telefono && (
                  <div>
                    <span className="text-slate-400 font-medium uppercase tracking-wide">Teléfono</span>
                    <p className="text-slate-700 font-medium">{proveedore.telefono}</p>
                  </div>
                )}
                {proveedore.Departamento?.name && (
                  <div>
                    <span className="text-slate-400 font-medium uppercase tracking-wide">Depto.</span>
                    <p className="text-slate-700 font-medium">{proveedore.Departamento.name}</p>
                  </div>
                )}
              </div>

              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => openModalForEdit(proveedore)}
                  className="flex-1 bg-white border border-slate-200 text-slate-600 py-2 rounded-lg hover:bg-slate-50 hover:text-indigo-600 transition-colors text-xs font-medium text-center"
                >
                  Editar
                </button>
                {proveedore.status === 1 ? (
                  <button
                    type="button"
                    onClick={() => handleToggleStatus(proveedore)}
                    className="flex-1 bg-red-50 text-red-600 border border-red-100 py-2 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium text-center"
                  >
                    Deshabilitar
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => handleToggleStatus(proveedore)}
                    className="flex-1 bg-emerald-50 text-emerald-600 border border-emerald-100 py-2 rounded-lg hover:bg-emerald-100 transition-colors text-xs font-medium text-center"
                  >
                    Activar
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Paginación */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mt-4 sm:mt-6 px-1 gap-3">
        <p className="text-sm text-slate-500 text-center sm:text-left">
          Página <span className="font-medium">{page}</span> de <span className="font-medium">{totalPages}</span>
        </p>
        <div className="flex gap-1 bg-white p-1 rounded-lg border border-slate-200 justify-center overflow-x-auto">
          <button
            disabled={page === 1}
            onClick={() => fetchData(page - 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === 1
              ? "text-slate-400 cursor-not-allowed"
              : "text-slate-600 hover:bg-slate-100"
              }`}
          >
            ← Ant
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => {
            if (totalPages > 7) {
              if (num === 1 || num === totalPages || (num >= page - 1 && num <= page + 1)) {
                return (
                  <button
                    key={num}
                    onClick={() => fetchData(num)}
                    className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === num
                      ? "bg-indigo-50 text-indigo-600"
                      : "text-slate-600 hover:bg-slate-100"
                      }`}
                  >
                    {num}
                  </button>
                );
              } else if (num === page - 2 || num === page + 2) {
                return <span key={num} className="px-2 py-1.5 text-slate-400">...</span>;
              }
              return null;
            }

            return (
              <button
                key={num}
                onClick={() => fetchData(num)}
                className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === num
                  ? "bg-indigo-50 text-indigo-600"
                  : "text-slate-600 hover:bg-slate-100"
                  }`}
              >
                {num}
              </button>
            );
          })}

          <button
            disabled={page === totalPages}
            onClick={() => fetchData(page + 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === totalPages
              ? "text-slate-400 cursor-not-allowed"
              : "text-slate-600 hover:bg-slate-100"
              }`}
          >
            Sig →
          </button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-start sm:items-center z-[100] p-2 sm:p-6 overflow-y-auto">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl flex flex-col my-4 sm:my-8 animate-fade-in-up">
            <div className="flex items-center justify-between p-4 sm:p-6 border-b border-slate-100 shrink-0">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h3 className="text-base sm:text-xl font-bold text-slate-800">
                  {editMode ? "Actualizar Proveedor" : "Registrar Nuevo Proveedor"}
                </h3>
              </div>
              <button
                onClick={() => setShowModal(false)}
                className="text-slate-400 hover:text-slate-600 transition-colors bg-slate-50 hover:bg-slate-100 rounded-full p-2"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-4 sm:p-6 overflow-y-auto custom-scrollbar flex-grow max-h-[65vh]">
              <form onSubmit={handleSubmit} id="proveedor-form" className="space-y-4 sm:space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Nombre/Representante</label>
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Nombre Comercial</label>
                    <input
                      type="text"
                      name="nombre_comercial"
                      value={form.nombre_comercial}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">NRC (N° Registro)</label>
                    <input
                      type="text"
                      name="nrc"
                      value={form.nrc}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">NIT</label>
                    <input
                      type="text"
                      name="nit"
                      value={form.nit}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">DUI</label>
                    <input
                      type="text"
                      name="dui"
                      value={form.dui}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Teléfono</label>
                    <input
                      type="text"
                      name="telefono"
                      value={form.telefono}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Correo Electrónico</label>
                    <input
                      type="email"
                      name="correo"
                      value={form.correo}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Estado</label>
                    <select
                      name="status"
                      value={form.status}
                      onChange={handleChange}
                      className={`w-full border border-slate-300 rounded-lg px-4 py-2.5 font-medium transition-colors focus:ring-2 focus:ring-indigo-500 outline-none text-sm ${form.status === "1"
                        ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                        : form.status === "0"
                          ? "bg-rose-50 text-rose-700 border-rose-200"
                          : "bg-white"
                        }`}
                      required
                    >
                      <option value="" disabled>Seleccione un estado...</option>
                      <option value="1">Activo</option>
                      <option value="0">Inactivo</option>
                    </select>
                  </div>

                  <div className="col-span-1 sm:col-span-2 lg:col-span-3">
                    <hr className="border-slate-100 my-2" />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Departamento</label>
                    <ReactSelect
                      options={opcionesDepartamento}
                      value={opcionesDepartamento.find((opt) => opt.value === form.departamento) || null}
                      onChange={(val) => handleSelectChange(val, "departamento")}
                      placeholder="Seleccionar..."
                      isSearchable
                      isClearable
                      classNamePrefix="react-select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
                          borderRadius: '0.5rem',
                          padding: '2px',
                          boxShadow: state.isFocused ? '0 0 0 2px rgba(99, 102, 241, 0.2)' : 'none',
                          '&:hover': {
                            borderColor: state.isFocused ? '#6366f1' : '#94a3b8'
                          }
                        })
                      }}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Municipio</label>
                    <ReactSelect
                      options={opcionesMunicipio}
                      value={opcionesMunicipio.find((opt) => opt.value === form.municipio) || null}
                      onChange={(val) => handleSelectChange(val, "municipio")}
                      placeholder="Seleccionar..."
                      isSearchable
                      isClearable
                      classNamePrefix="react-select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
                          borderRadius: '0.5rem',
                          padding: '2px',
                          boxShadow: state.isFocused ? '0 0 0 2px rgba(99, 102, 241, 0.2)' : 'none',
                          '&:hover': {
                            borderColor: state.isFocused ? '#6366f1' : '#94a3b8'
                          }
                        })
                      }}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Actividad Económica</label>
                    <ReactSelect
                      options={opcionesActividad}
                      value={opcionesActividad.find((opt) => opt.value === form.actividad) || null}
                      onChange={(val) => handleSelectChange(val, "actividad")}
                      placeholder="Seleccionar..."
                      isSearchable
                      isClearable
                      classNamePrefix="react-select"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? '#6366f1' : '#cbd5e1',
                          borderRadius: '0.5rem',
                          padding: '2px',
                          boxShadow: state.isFocused ? '0 0 0 2px rgba(99, 102, 241, 0.2)' : 'none',
                          '&:hover': {
                            borderColor: state.isFocused ? '#6366f1' : '#94a3b8'
                          }
                        })
                      }}
                    />
                  </div>

                  <div className="col-span-1 sm:col-span-2 lg:col-span-3">
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Dirección Exacta</label>
                    <textarea
                      name="direccion"
                      value={form.direccion}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors min-h-[100px] resize-y text-sm"
                      required
                    ></textarea>
                  </div>
                </div>
              </form>
            </div>

            <div className="p-4 sm:p-6 border-t border-slate-100 bg-slate-50 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-3 rounded-b-2xl shrink-0">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="w-full sm:w-auto px-5 py-2.5 rounded-lg border border-slate-300 text-slate-700 font-medium hover:bg-white focus:ring-2 focus:ring-slate-200 transition-colors text-sm"
                disabled={submitting}
              >
                Cancelar
              </button>

              <button
                type="submit"
                form="proveedor-form"
                disabled={submitting}
                className={`w-full sm:w-auto px-6 py-2.5 rounded-lg flex items-center justify-center gap-2 font-medium shadow-sm transition-all text-sm text-white ${submitting
                  ? "bg-indigo-400 cursor-not-allowed shadow-none"
                  : "bg-indigo-600 hover:bg-indigo-700 hover:shadow-indigo-200"
                  }`}
              >
                {submitting && (
                  <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                {submitting
                  ? editMode
                    ? "Actualizando..."
                    : "Guardando..."
                  : editMode
                    ? "Actualizar Proveedor"
                    : "Guardar Proveedor"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Proveedores;
